import { useEffect, useState } from 'react';
import useSearchParams from '../../../../../../../hooks/useSearchParams';
import {
  ORDER_TARGETS_TAB_EXPAND_PARAM,
  getExpandTargetParam,
} from '../../../../../utils/orderTargetsTab.utils';

const toExpandedIds = (targetId: string | null) => new Set(targetId ? [targetId] : []);

const useOrderTargetsExpandedIds = () => {
  const { searchParams, removeSearchParams } = useSearchParams();
  const targetIdToExpand = getExpandTargetParam(searchParams);
  const [expandedIds, setExpandedIds] = useState<Set<string>>(() =>
    toExpandedIds(targetIdToExpand),
  );
  const [appliedTargetId, setAppliedTargetId] = useState(targetIdToExpand);

  if (targetIdToExpand !== appliedTargetId) {
    setAppliedTargetId(targetIdToExpand);

    if (targetIdToExpand) {
      setExpandedIds(toExpandedIds(targetIdToExpand));
    }
  }

  useEffect(() => {
    if (getExpandTargetParam(searchParams)) {
      removeSearchParams([ORDER_TARGETS_TAB_EXPAND_PARAM]);
    }
  }, [searchParams, removeSearchParams]);

  return { expandedIds, setExpandedIds };
};

export default useOrderTargetsExpandedIds;
